import { useRouter } from "next/router";
import { useQuery } from "@apollo/client";
import { GET_SHARE_LINK_URL } from "@/graphql/queries/user";
import { Spinner } from "@aqar-app/react-ui";
import css from "./.module.scss";
import { InitialResolver } from "@/lib/use.middlewares";
export default function Share() {
  const router = useRouter();
  const { code } = router.query;
  useQuery(GET_SHARE_LINK_URL, {
    skip: !code,
    variables: { code },
    onCompleted: (data) => {
      const url = data.User.getShareLinkUrl;

      if (!url) return router.push("/404");
      window.location.replace(url);
    },
    onError: () => router.push("/404"),
  });

  return (
    <div className={css.root}>
      <Spinner />
    </div>
  );
}

Share.getInitialProps = InitialResolver();
